// import { SurveyTransaction } from '../survey-transaction/survey-transaction.interface';
// import { Survey } from '../survey/survey-entity.interface';
// import { ComposedQuestion } from './composed-question/composed-question-builder.class';
import { QuestionAnswerObject } from '@hyper-inferno/survey-elements-core';
import { ComposedPage } from '../page/composed-page.builder';
import { InteractionTypes } from './interaction-types.interface';
import { QuestionAttachmentType } from './question-attachment-type.enum';

export enum CrossFrameMessageTypes {
  EMBED_READY = 'EMBED_READY',
  CONTROLLER_MESSAGE = 'CONTROLLER_MESSAGE',
  CONTROLLER_RELOAD_COMMAND = 'CONTROLLER_RELOAD_COMMAND',
  EMBED_MESSAGE = 'EMBED_MESSAGE',
}

export enum ChatMessageTypes {
  StartConsent = 'B-start-consent',
  // Question = 'B-question',
  Page = 'B-page',
  EndPage = 'B-end-page',

  InvalidResponse = 'B-invalid-response',
  EndSurvey = 'B-end-survey',
  TerminateSurvey = 'B-terminate-survey',
  NotExpectingResponse = 'B-not-expecting-response',
  Answer = 'C-answer',
  SelfStart = 'C-self-start',
  UserToOperator = 'C-chat-with-operator',
  C_AcceptConsent = 'C-accept-consent',
  C_RejectConsent = 'C-reject-consent',
  OperatorToUser = 'O-chat-with-user',
  OperatorConsent = 'B-Operator-start-consent',
  ChatTimeout = 'B-chat-timeout',
  C_InvalidResponse = 'C-invalid-response',
  UNKNOWN = 'B-UNKNOWN',
  BOT_ERROR = 'B-ERROR',
  BOT_END_REDIRECT = 'B-end-survey-with-redirect',
}

export interface CrossFrameMessage {
  type: CrossFrameMessageTypes;
  chatMessage?: ChatMessage;
  data?: any;
}

export interface ChatMessage {
  recipient?: string;
  sender?: string;
  messageType: ChatMessageTypes;
  message?: string;
  // question?: ComposedQuestion;
  page?: ComposedPage;
  // surveyTransaction?: SurveyTransaction;
  // survey?: Survey;
  interactiveMessage?: InteractiveMessage;
  redirectInfo?: RedirectInfo;
  autoAdvance?: boolean;
  messageTime?: string;
  messageMediaUrl?: string;
  mediaType?: QuestionAttachmentType;
}

export interface RedirectInfo {
  url: string | undefined;
  delay: number;
}

export interface InteractiveMessage {
  type: InteractionTypes;
  languageChangePayload?: {
    language: string;
  };
  switchQuestionPayload?: {
    isNext: boolean;
  };
  customSwitchQuestionPayload?: {
    questionId: number | any;
  };
  submitAnswerPayload?: {
    answerObject: QuestionAnswerObject;
  };
  skipQuestionPayload?: {
    questionId: number;
    answerObject: QuestionAnswerObject;
  };

  loginPayload?: {
    surveyId: number;
    params: QuestionAnswerObject;
    answerObject: QuestionAnswerObject;
  };
}

// Format in which the Survey App sends a response to the API
export interface SurveyClientResponse {
  payload: ChatMessage;
}
